var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32422 1.4375C1.85823 1.4375 1.48047 1.81526 1.48047 2.28125V10.7188C1.48047 11.1847 1.85823 11.5625 2.32422 11.5625H14.1367C14.6027 11.5625 14.9805 11.1847 14.9805 10.7188V2.28125C14.9805 1.81526 14.6027 1.4375 14.1367 1.4375H2.32422ZM0.355469 2.28125C0.355469 1.19394 1.23691 0.3125 2.32422 0.3125H14.1367C15.224 0.3125 16.1055 1.19394 16.1055 2.28125V10.7188C16.1055 11.8061 15.224 12.6875 14.1367 12.6875H2.32422C1.23691 12.6875 0.355469 11.8061 0.355469 10.7188V2.28125Z",
    fill: "#8493B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72396 2.77966C2.91469 2.53444 3.26809 2.49026 3.51331 2.68099L8.23047 6.34989L12.9476 2.68099C13.1928 2.49026 13.5463 2.53444 13.737 2.77966C13.9277 3.02488 13.8835 3.37828 13.6383 3.56901L8.57581 7.50651C8.37269 7.6645 8.08825 7.6645 7.88513 7.50651L2.82263 3.56901C2.57741 3.37828 2.53323 3.02488 2.72396 2.77966Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconForm);
export default __webpack_public_path__ + "static/media/email_icon_Form.bb3da8baafa80b9643b3d61042339580.svg";
export { ForwardRef as ReactComponent };